<template>
    <div v-if="trap">
        <h2>{{ trap.name }}</h2>
        <span>{{ trap.serialNumber }}</span>
        <br />
        <template v-if="trap.status">
            <v-chip
                small
                v-if="trap.status.right && trap.status.left"
                color="green"
                class="chip-status"
                text-color="white"
                >{{ $t("status.armed") }}</v-chip
            >
            <v-chip
                small
                v-else-if="!trap.status.right && !trap.status.left"
                color="red"
                class="chip-status"
                text-color="white"
                >{{ $t("status.triggered") }} 2/2</v-chip
            >
            <v-chip
                small
                v-else-if="!trap.status.right || !trap.status.left"
                color="orange"
                class="chip-status"
                text-color="white"
                >{{ $t("status.triggered") }} 1/2</v-chip
            >
            <v-chip
                small
                :color="getBatteryColor(trap.status.battery)"
                class="chip-battery hidden-sm-and-down"
                text-color="white"
            >
                <v-avatar>
                    <v-icon>battery_full</v-icon>
                </v-avatar>
                {{ trap.status.battery }}%
            </v-chip>
            <v-chip
                small
                :color="getBatteryColor(trap.status.signal)"
                class="chip-battery hidden-sm-and-down"
                text-color="white"
            >
                <v-avatar>
                    <v-icon>signal_cellular_alt</v-icon>
                </v-avatar>
                {{ trap.status.signal }}%
            </v-chip>
        </template>
        <v-chip outlined v-else class="chip-status" small>{{ $t("status.no") }}</v-chip>
    </div>
</template>

<script>
export default {
    props: { trap: { type: Object, required: true } },
    methods: {
        getBatteryColor(percent) {
            if (!percent) {
                return ""
            }

            if (percent > 60) {
                return "green"
            }
            if (percent > 40) {
                return "amber darken-1"
            }
            if (percent > 20) {
                return "orange"
            }
            return "red"
        },
    },
}
</script>
